import { Button, Col, Form, InputNumber, notification, Row } from 'antd';
import { plantApi } from 'api/plantApi';
import { useAppSelector } from 'app/hooks';
import { selectIsDisable } from 'features/Login/authSlice';
import { selectPlantInfo } from 'features/Plant/plantSlice';
import { objectPlantInfo } from 'models';
import * as React from 'react';
import { FiEdit } from 'react-icons/fi';
import style from './ElectricityCost.module.scss';
export interface ElectricityCostProps {}

export default function ElectricityCost(props: ElectricityCostProps) {
  const [form] = Form.useForm();
  const itemPlant = useAppSelector(selectPlantInfo);
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [electricity, setElectricity] = React.useState<any>(null);
  const isDisable = useAppSelector(selectIsDisable);

  React.useEffect(() => {
    if (itemPlant) {
      (async () => {
        const response: objectPlantInfo = await plantApi.fetchElectricityPrice({
          type: 'electricity-price',
          id: itemPlant.id,
        });
        setElectricity({ currency: response.electricity_price });
      })();
    }
  }, [itemPlant]);
  // React.useEffect(() => {
  //   if (itemPlant) {
  //     (async () => {
  //       const response: objectPlantInfo = await plantApi.fetchElectricityPrice({
  //         type: 'electricity-price',
  //         id: itemPlant.id,
  //       });
  //       setElectricity({ currency: response.electricity_price });
  //     })();
  //   }
  // }, []);

  const handleSubmit = async (value: any) => {
    try {
      setElectricity({ currency: value.currency });
      setIsModalVisible(false);
      plantApi.editElectricityPrice({
        type: 'electricity-price',
        id: itemPlant?.id,
        electricity_price: value.currency,
      });
      openNotificationWithIcon('success', 'Update electricity cost successfully');
    } catch (error) {
      openNotificationWithIcon('error', 'please check the data again!');
    }
  };

  const openNotificationWithIcon = (type: string, message: string) => {
    if (type === 'success' || type === 'error') notification[type]({ message: message });
    return;
  };

  return (
    <Row className={style.root}>
      <Row className={style.header_info}>
        <Col span={19} className={style.header_label_info}>
          Electricity Cost
        </Col>
        <Col span={5} className={style.header_group_btn}>
          {isModalVisible ? (
            <Button
              className={style.btn_cancel}
              onClick={() => {
                form.resetFields();
                setIsModalVisible(false);
              }}
            >
              Cancel
            </Button>
          ) : (
            <div></div>
          )}

          <Button
            disabled={isDisable}
            className={style.btn_edit}
            onClick={() => {
              form.submit();
            }}
          >
            Save
            <FiEdit style={{ marginLeft: '10px' }} />
          </Button>
        </Col>
      </Row>
      <Row className={style.main_detail} align="top">
        {electricity && (
          <Form
            form={form}
            initialValues={electricity}
            layout="vertical"
            hideRequiredMark
            onValuesChange={() => setIsModalVisible(true)}
            onFinish={(values) => handleSubmit(values)}
            labelCol={{
              span: 18,
            }}
            wrapperCol={{
              span: 5,
            }}
            style={{ width: '100%' }}
          >
            <Form.Item
              name="currency"
              label="Giá điện cấp vào lưới ( VND/kWh)"
              rules={[{ required: true, message: 'Please enter electricity cost' }]}
            >
              <InputNumber style={{ width: '250px' }} placeholder="Please enter electricity cost" />
            </Form.Item>
          </Form>
        )}
      </Row>
    </Row>
  );
}
